var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"mr-2",class:_vm.customData.field.iconClass,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('on:icon-click')}}}),_c('b-title',{class:_vm.customData.field.labelClass},[_vm._v(" "+_vm._s(_vm.customData.field.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }